<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Journals</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="searchPublication"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col"></div>
        <div class="col pl-2">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Journal
            </v-btn>
          </div>
        </div>
      </div>

      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-text-field
                id="ISSN"
                v-model="selectedObj.ISSN"
                :rules="ISSNRules"
                label="ISSN *"
                required
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="Title"
                v-model="selectedObj.Title"
                label="Title*"
                :rules="TitleRules"
                required
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <file-drop
                v-on:update="logFiles($event)"
                v-on:clear="clearFile"
                :fileName="fileName"
                id="dropFile"
              ></file-drop>
              <div v-show="fileSize > 0">Size: {{ this.fileSize }} MB</div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-checkbox
                id="default"
                v-model="isDefaultThumbnail"
                label="Use default thumbnail"
                @change="isDefaultThumbnailChanged"
              ></v-checkbox>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-10">
                  <v-file-input
                    id="ThumbnailImage"
                    accept="image/png, image/jpeg"
                    placeholder="Thumbnail"
                    prepend-icon="mdi-camera"
                    label="Thumbnail*"
                    v-model="thumbnailData"
                    @change="loadTumbnail"
                    @click:clear="clearFile"
                    required
                    v-show="!isDefaultThumbnail"
                  ></v-file-input>
                </div>
                <div class="col-2 ThumbnailImg" style="width: 50px">
                  <div class="float-right">
                    <img
                      :src="ThumbnailPath"
                      width="50"
                      id="thubnailImageview"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-select
                id="journal"
                v-model="journalTypesSelected"
                :items="journalTypes"
                label="Journal Type*"
                item-text="name"
                item-value="id"
                return-object
                :rules="JournalTypesRules"
              ></v-select>
            </div>
            <div class="col"></div>
          </div>

          <div class="row">
            <div class="col">
              <v-text-field
                id="Publisher"
                v-model="selectedObj.Publisher"
                label="Publisher"
                required
                max="500"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="Frequency"
                v-model="selectedObj.Frequency"
                label="Frequency"
                required
                max="500"
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-textarea
                id="Scope"
                v-model="selectedObj.Scope"
                label="Scope"
                max="1000"
              ></v-textarea>
            </div>
            <div class="col">
              <v-textarea
                id="EditorialBoard"
                v-model="selectedObj.EditorialBoard"
                label="Editorial Board"
                max="1000"
              ></v-textarea>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-textarea
                id="PeerReviewProcess"
                v-model="selectedObj.PeerReviewProcess"
                label="Peer Review Process"
                max="1000"
              ></v-textarea>
            </div>
            <div class="col">
              <v-textarea
                id="ImpactFactor"
                v-model="selectedObj.ImpactFactor"
                label="Impact Factor"
                max="1000"
              ></v-textarea>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-text-field
                id="Indexing"
                v-model="selectedObj.Indexing"
                label="Indexing"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="EntryDates"
                v-model="selectedObj.EntryDates"
                label="Entry Dates"
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-textarea
                id="Content"
                v-model="selectedObj.Content"
                label="Content"
                max="1000"
              ></v-textarea>
            </div>
            <div class="col">
              <v-textarea
                id="Privacy"
                v-model="selectedObj.Privacy"
                label="Privacy"
                max="1000"
              ></v-textarea>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-text-field
                id="Organization"
                v-model="selectedObj.Organization"
                label="Organization"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="Customization"
                v-model="selectedObj.Customization"
                label="Customization"
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-textarea
                id="TargetAudience"
                v-model="selectedObj.TargetAudience"
                label="Target Audience"
                max="1000"
              ></v-textarea>
            </div>
          </div>

          <v-divider class="pt-5"></v-divider>

          <div class="row mb-4">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </div>
      <div class="row mt-5" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ISSN</th>
                  <th class="text-left">Title</th>
                  <th class="text-left">Journal Type</th>
                  <th class="text-left">Publisher</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + i">
                  <td>{{ item.ISSN }}</td>
                  <td>{{ item.Title }}</td>
                  <td>
                    {{ getJournalType(item.JournalType) }}
                  </td>
                  <td>
                    {{ item.Publisher != null ? item.Publisher : "" }}
                  </td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import FileDrop from "../components/FileDrop";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import VueUploadComponent from "vue-upload-component";
import Pagination from "@/components/Pagination";
import * as api from "@/api";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "Journals",
  components: {
    Notification,
    FileUpload: VueUploadComponent,
    FileDrop,
    ConfirmationDialog,
    Pagination,
  },
  computed: {},
  created() {
    this.getJournalsByPagin();
    this.getJournals();
  },
  methods: {
    getJournals() {
      this.UserTypes = [];
      new Promise((resolve, reject) => {
        api
          .getAll("journal/journal-types")
          .then((response) => {
            this.journalTypes = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getJournalsByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getJournalsByPagin();
    },
    onNew() {
      this.isEdit = true;
      this.id = 0;
      this.uuid = 'J-' + uuidv4();
      this.selectedObj = Object.assign({}, null);
      this.selectedObj.id = 0;
      this.thumbnailFileName = "";
      this.isDefaultThumbnail = false;
      this.thumbnailUrl = "";
      this.fileSize = 0;
      this.thumbnailData = "";
      this.ThumbnailPath = "";
      this.ThumbnailPathOld = "";
      this.thumbnailFileName = "";
    },
    onEdit(obj) {
      this.$refs.form.resetValidation();
      this.isEdit = true;
      this.id = obj.id;
      this.journalTypesSelected = { id: obj.JournalType };
      obj.file = {};
      this.selectedObj = Object.assign({}, obj);
      this.uuid = obj.uuid;
      this.ThumbnailFileType = obj.ThumbnailFileType;
      this.isDefaultThumbnail = obj.isDefaultThumbnail;
      this.ThumbnailPath = obj.ThumbnailPath;
      this.ThumbnailPathOld = obj.ThumbnailPath;
    },
    onSave() {
      let that = this;
      that.overlay = true;

      if (this.thumbnailFileName != "")
        this.ThumbnailFileType = this.thumbnailFileName.split(".").pop();

      if (this.fileName != "")
        this.PublicationFileType = this.fileName.split(".").pop();

      if (this.ThumbnailPath.includes("data:image")) {
        this.ThumbnailPath = "";
      }

      console.log(this.ThumbnailFileType);

      this.$refs.form.validate();
      if (!this.valid) return;

      if (this.thumbnailFileName != "")
        this.ThumbnailFileType = this.thumbnailFileName.split(".").pop();

      if (this.fileName != "")
        this.PublicationFileType = this.fileName.split(".").pop();

      console.log(this.journalTypesSelected);

      this.selectedObj.JournalType = this.journalTypesSelected.id;
      this.selectedObj.ThumbnailPath = this.ThumbnailPath;
      this.selectedObj.ThumbnailFileType = this.ThumbnailFileType;
      this.selectedObj.isDefaultThumbnail = this.isDefaultThumbnail;
      // this.selectedObj.file = this.file;
      this.selectedObj.file = null;
      this.selectedObj.fileName = this.fileName;
      this.selectedObj.thumbnail = this.thumbnail;
      this.selectedObj.thumbnailFileName = this.thumbnailFileName;
      
      this.selectedObj.uuid = this.uuid;

      const fileExt = this.fileName.split('.').pop();

      console.log(this.selectedObj);

      new Promise((resolve, reject) => {
        if (this.fileName == "" && this.selectedObj.id !== 0) {
          api
            .update("journal", this.selectedObj)
            .then((response) => {
              resolve(response);
              console.log(response.status);
              console.log(response);
              if (response.status === 200 || response.status === 201) {
                this.isEdit = false;
                this.notify.type = 1;
                if (this.id == 0) {
                  this.notify.message = "Record successfully created.";
                } else {
                  this.notify.message = "Record successfully updated.";
                }
                this.getJournalsByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
        } else {
        api
          .post("journal/signed-url", {mimeType: fileExt, contentId: this.selectedObj.uuid}).then((response) => {
            resolve(response);
            console.log(response.status);
            console.log(response);
            if (response.status === 200 || response.status === 201) {
              // this.isEdit = false;
              return response;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to upload file.");
            }
          })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              var fileExt = this.fileName.split('.').pop();
              const fetchResponse = fetch (response.data.url, {
                method: "PUT",
                headers: {
                  "Content-Type": fileExt,
                },
                body: this.file,
              });
              console.log("Upload complete:", this.fileName);
              return fetchResponse;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to upload file.");
            }
          }).then((response) => {
          api
            .update("journal", this.selectedObj)
            .then((response) => {
              resolve(response);
              console.log(response.status);
              console.log(response);
              if (response.status === 200 || response.status === 201) {
                this.isEdit = false;
                this.notify.type = 1;
                if (this.id == 0) {
                  this.notify.message = "Record successfully created.";
                } else {
                  this.notify.message = "Record successfully updated.";
                }
                this.getJournalsByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
          }).
          finally(() => {
            this.overlay = false;
            this.$refs.form.reset();
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data.");
            console.error("Error saving data:", error);
            reject(error);
          });
        }
      })
    },
    onCancel() {
      this.isEdit = false;
      this.$refs.form.reset();
      this.notify.errors.splice(0, this.notify.errors.length);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("journal", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getJournalsByPagin();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
      this.isEdit = false;
    },
    getJournalsByPagin() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("journal", this.paging)
          .then((response) => {
            that.overlay = false;
            console.log(response.data.data);
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            that.overlay = false;
            reject(error);
          });
      });
    },

    logFiles(fileList) {
      this.fileSize = 0;
      console.log(fileList);
      this.fileName = fileList[0].name;
      this.journal_file_length = fileList[0].size;
      console.log(this.fileName);
      console.log(fileList[0].size);
      this.file = fileList[0]; 
      this.selectedObj.journal_file_length = fileList[0].size;

      this.fileSize = (fileList[0].size / (1024 * 1024)).toFixed(2);
    },
    clearFile() {
      this.ThumbnailPath = "";
      this.fileSize = false;
    },
    loadTumbnail(e) {
      this.thumbnailFileName = this.thumbnailData.name;
      const reader = new FileReader();
      reader.readAsDataURL(this.thumbnailData);
      //reader.onload = () => resolve(reader.result); // reader.result
      reader.onload = (result) => {
        console.log(result.currentTarget.result);
        this.thumbnail = result.currentTarget.result;
        this.ThumbnailPath = result.currentTarget.result;
      };
      reader.onerror = (error) => reject(error);
    },
    isDefaultThumbnailChanged() {
      if (this.isDefaultThumbnail) {
        this.thumbnailUrl = "File: Default_Thumbnail.jpg";
        this.ThumbnailPath =
          "https://storage.googleapis.com/prothumia/eBooks/Default_Thumbnail.png";
      } else {
        this.thumbnailUrl =
          "File: " + this.uuid + "." + this.ThumbnailFileType == ""
            ? "jpg"
            : this.ThumbnailFileType;
        this.ThumbnailPath = this.ThumbnailPathOld;
      }
    },

    getJournalType(id) {
      switch (id) {
        case 1:
          return "Academic Journals";
        case 2:
          return "Personal Journals";
        case 3:
          return "Professional Journals";
      }
    },
  },
  data: () => {
    return {
      id: 0,
      list: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {
        id: 0,
        ISSN: "",
      },
      uuid: "",
      journal_file_length: 0,
      journalTypes: [],
      journalTypesSelected: {},
      ISSNRules: [(v) => !!v || "ISSN is required"],
      TitleRules: [(v) => !!v || "Title is required"],
      JournalTypesRules: [(v) => !!v || "Journal types is required"],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      valid: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      files: [],
      file: {},
      fileName: "",
      thumbnailRules: [
        (v) =>
          (!!v && isDefaultThumbnail) ||
          "Thumbnail is required" ||
          !v ||
          v.size < 2000000 ||
          "Thumbnail size should be less than 2 MB!",
      ],
      isDefaultThumbnail: false,
      thumbnailUrl: "",
      fileSize: 0,
      thumbnailData: "",
      ThumbnailPath: "",
      ThumbnailPathOld: "",
      thumbnailFileName: "",
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/Journal.vue